import Http from './http.js';
import { http1,http2 } from './http.js';
//获取个人信息（关注数&粉丝）
const getProfile = (data) => {
    return Http('get', `pdapi/member/profile/`, data);
};
//获取关注人信息（关注数&粉丝）
const getOtherProfile = (data) => {
    return Http('get', `pdapi/member/profile/` + data, null);
};
// 获取个人帖子列表
const getTopics = (data) => {
    return Http('get', `pdapi/topic/topics`, data);
};
// 获取分区帖子列表
const getPartitionList = (data) => {
    return Http('get', `pdapi/topic/topics/partition`, data);
};
// 获取关注用户列表
const getFollows = (data) => {
    return Http('get', `pdapi/member/follows`, data);
};
// 获取他人关注用户列表
const getOtherFollows = (id, data) => {
    return Http('get', `pdapi/member/follows/${id}`, data);
};
// 获取粉丝用户列表
const getFans = (data) => {
    return Http('get', `pdapi/member/fans`, data);
};
// 获取他人粉丝用户列表
const getOtherFans = (id, data) => {
    return Http('get', `pdapi/member/fans/${id}`, data);
};
// 帖子详情
const getDetail = (data) => {
    return Http('get', `pdapi/topic/detail/` + data, null);
};
// 游戏内到指定帖子
const getDetail2 = (data) => {
    return Http('get', `pdapi/topic/detail/0`, data);
};
// 查询评论列表
const getCommentList = (id, data) => {
    return Http('get', `pdapi/topic/commentList/` + id, data);
};
// 帖子点赞接口
const likeClick = (data) => {
    return Http('get', `pdapi/topic/like/` + data, null);
};
// 获取帖子点赞列表
const likeMemberList = (id, data) => {
    return Http('get', `/pdapi/topic/likeMemberList/${id}`, data);
};
// 评论点赞接口
const commentLikeClick = (data) => {
    return Http('get', `pdapi/topic/comment/like/` + data, null);
};
// 评论点踩接口
const commentBadClick = (id) => {
    return Http('get', `/pdapi/topic/comment/bad/${id}`, null);
};


// 社区首页载入
const getIndexInfo = (data) => {
    return Http('post', `indexInfo`, data);
};
// 获取banner和官方动态帖子
const getBanner = (data) => {
    return Http('get', `/pdapi/topic/home/top`, data);
};
// 社区搜索
const getSearchData = (data) => {
    return Http('post', `/pdapi/search/searchdata`, data);
};
// 获取热搜词
const getHotWords = (data) => {
    return Http('post', `/pdapi/search/hotword`, data);
};
//推荐关注列表
const getfollowsList = (data) => {
    return Http('get', `/pdapi/member/recommend/follows`, data);
};
// 评论帖子/回复评论
const topicComment = (url, data) => {
    return Http('post', `pdapi/topic/comment/` + url, data);
};
// 帖子收藏
const favor = (id) => {
    return Http('get', `/pdapi/topic/favor/${id}`, null);
};
// 帖子点踩
const bad = (id) => {
    return Http('get', `/pdapi/topic/bad/${id}`, null);
};
//玩家举报/反馈接口
const report = (data) => {
    return Http('post', `/pdapi/member/report`, data);
};
//删除帖子
const deletePost = (id) => {
    return Http('post', `/pdapi/topic/delete/${id}`, null);
};
//删除帖子评论/回复
const deleteComments = (id) => {
    return Http('post', `/pdapi/topic/comment/delete/${id}`, null);
};

//發布
//发帖
const topicPost = (data) => {
    return Http('post', `/pdapi/topic/post`, data);
};
// 编辑
const topicEdit = (data) => {
    return Http('post', `/pdapi/topic/editPost`, data);
};
//创建话题
const subjectCreate = (data) => {
    return Http('post', `/pdapi/subject/create`, data);
};
//话题列表
const subjectList = (data) => {
    return Http('get', `/pdapi/subject/list`, data);
};
//最近使用的话题列表
const recordlyList = () => {
    return Http('get', `/pdapi/subject/recordlyList`, null);
};

//消息
//初始
const messageList = (data) => {
    return Http('get', `/pdapi/member/messageList`, data);
};
//关注&取消关注
const follow = (id) => {
    return Http('post', `/pdapi/member/follow/${id}`, null);
};
//查询回复列表
const replyList = (id, data) => {
    return Http('get', `/pdapi/topic/replyList/${id}`, data);
};
//上报已读
const messageRead = (data) => {
    return Http('post', `/pdapi/member/messageRead`, data);
};
//获取玩家消息接受设置
const queryMessageSet = () => {
    return Http('get', `/pdapi/member/queryMessageSet`, null);
};
//修改玩家消息接受设置
const updateMessageSet = (data) => {
    return Http('post', `/pdapi/member/updateMessageSet`, data);
};
//根据评论id查询评论详情
const detail = (id) => {
    return Http('get', `/pdapi/topic/comment/detail/${id}`, null);
};

//个人主页
//修改头像
const avatar = (data) => {
    return Http('post', `/pdapi/member/avatar`, data);
};
//修改昵称
const nickname = (data) => {
    return Http('post', `/pdapi/member/nickname`, data);
};
//获取cos云存储临时私钥
const getCosTemToken = (data) => {
    return Http('get', `/pdapi/picture/getCosTemToken`, data);
};
//建议反馈接口
const feedback = (data) => {
    return Http('post', `/pdapi/member/feedback`, data);
};
//分享页面初始化
const shareDetail = (data) => {
    return Http('get', `/pd/ext/shareDetail/${data}`);
};
//分享页面初始化
const shareCommentList = (data) => {
    return Http('get', `/pd/ext/shareCommentList/${data}`, data);
};
// 分享接口打点
const shareStatistics = (id, data) => {
    return Http('get', `/pdapi/topic/share/${id}`, data);
};


// 百科
//获取标签列表
const taglist = (data) => {
    return Http('get', `/pdapi/baike/taglist`, data);
};
//根据标签id获取百科列表
const baikeList = (data) => {
    return Http('get', `/pdapi/baike/list`, data);
};

//推荐版主
const webmaster = (data) => {
    return Http('get', `/pdapi/member/recommend/webmaster`, data);
};

//获取未读消息数
const unReadMessageNum = (data) => {
    return Http('get', `/pdapi/member/unReadMessageNum`, data);
};

//获取登陆码
const findLogincode = (data) => {
    return Http('get', `/pdapi/member/logincode/find`, data);
};
//刷新登陆码
const refreshLogincode = (data) => {
    return Http('get', `/pdapi/member/logincode/refresh`, data);
};
//微信内登陆码登陆
const bindLogincode = (data) => {
    return Http('post', `/wxLogin`, data);
};
//微信内登陆码登出
const unbindLogincode = (data) => {
    return Http('post', `/pdapi/member/logincode/unbind`, data);
};


// 查询认证条件
const  authCond= (data) => {
    return Http('post', `/pdapi/member/authenticate/authCond`, data);
};
// 申请认证
const  authApply= (data) => {
    return Http('post', `/pdapi/member/authenticate/authApply`, data);
};
// 更换认证
const  authChange= (data) => {
    return Http('post', `/pdapi/member/authenticate/authChange`, data);
};
// 取消认证
const  authCancel= (data) => {
    return Http('post', `/pdapi/member/authenticate/authCancel`, data);
};

// 修改个性签名
const  introduce= (data) => {
    return Http('post', `/pdapi/member/introduce`, data);
};
// 查询认证头衔列表
const  authTitles= (data) => {
    return Http('post', `/pdapi/member/authenticate/authTitles`, data);
};

//手机账号登录发送验证码
const  sendCode= (data,config) => {
    return http1('get', `/passport/main.zlongame`, data,config);
};
//手机账号登录
const  phoneLogin= (data) => {
    return http1('get', `/passport/method_login.zlongame`, data);
};
//小程序手机账号一键登录
const  xcxPhoneLogin= (data) => {
    return http1('get', `/passport/account/v2/user/login/onekey.do`, data);
};
//网页登录
const  webLogin= (data) => {
    return Http('post', `/pdapi/member/login`, data);
};
//网页登录
const  webLogoff= (data) => {
    return Http('post', `/pdapi/member/logoff`, data);
};
//网页登录
const  useBindCode = (data) => {
    return Http('post', `/pdapi/member/bindCodeUse`, data);
};
//绑定码查询
const  bindCodeQuery = (data) => {
    return Http('post', `/pdapi/member/bindCodeQuery`, data);
};
//绑定码
const  bindCode= (data) => {
    return Http('post', `/pdapi/member/bindCodeConfirm`, data);
};
//手机账号绑定查询
const  bindPhoneQuery = (data) => {
    return Http('post', `/pdapi/member/bindPhoneQuery`, data);
};
//手机账号绑定
const  bindPhone = (data) => {
    return Http('post', `/pdapi/member/bindPhoneConfirm`, data);
};
// 查询经验值明细
const getExplist = (data) => {
    return Http('post', `/pdapi/member/expoint/explist`, data);
};

// 查询积分获得明细
const getPointAddList = (data) => {
    return Http('post', `/pdapi/member/expoint/pointaddlist`, data);
}

// 查询积分消耗明细
const getPointConsList = (data) => {
    return Http('post', `/pdapi/member/expoint/pointconslist`, data);
}

// 获取经验值等级明细
const getExpRule = (data) => {
    return Http('post', `/pdapi/member/expoint/exprule?t=${new Date().getTime()}`, data);
}

// 兑换中心商品列表

const getExGoodsList = (data) => {
    return Http('get', `/pdapi/exchange/goodslist`, data);
}

// 兑换购买商品
const buyGoods = (data) => {
    return Http('post', `/pdapi/exchange/buyGoods`, data);
}


// 兑换记录
const getRecordList = (data) => {
    return Http('get', `/pdapi/exchange/recordList`, data);
}
//兑换详情（订单详情）
const getRecordDetail = (data) => {
    return Http('get', `/pdapi/exchange/recordDetail`, data);
}

// 商品详情
const getGoodDetail = (data) => {
    return Http('get', `/pdapi/exchange/queryGoodsDetail`, data);
}

//查累计签到奖励与进度
const reward = (data) => {
    return Http('get', `/pdapi/task/sign/reward`, data);
};
//每日任务与特殊任务进度
const daily = (data) => {
    return Http('get', `/pdapi/task/daily`, data);
};
//签到
const sign = (data) => {
    return Http('get', `/pdapi/task/sign`, data);
};
//查询有多少任务积分待领取
const notobtain = (data) => {
    return Http('get', `/pdapi/task/score/notobtain`, data);
};
//查询是否有礼包新上
const subTitle = (data) => {
    return Http('get', `/pdapi/exchange/subTitle`, data);
};
//查询社区等级及积分
const profile = (data) => {
    return Http('get', `/pdapi/task/profile`, data);
};

//查询钢岚游戏信息列表
const getGlGameinfo = (data) => {
    return http2('get', `/common/infodata/mQuery.do`, data);
};

const getTechRelateInfo = (data) => {
    return Http('get', `/pdapi/topic/relate_topics`, data);
};

//查询钢岚战备攻略页面主体信息
const getGlGameintro = (data) => {
    return Http('get', `/pdapi/topic/feature/summary`, data);
};
//查询钢岚战备攻略页面banner
const getGlGameintroBanner = (data) => {
    return Http('get', `/pdapi/topic/feature/top`, data);
};
//查询钢岚战备攻略页面导航list
const getGlGameintroNav = (data) => {
    return Http('get', `/pdapi/topic/feature/navigation`, data);
};
//查询钢岚战备攻略页面导航icon
const getGlGameintroNavIcon = (data) => {
    return Http('get', `/pdapi/topic/feature/menuicon`, data);
};
//查询钢岚战备攻略页面列表详细信息
const getGlGameintroInfos = (data) => {
    return Http('get', `/pdapi/topic/feature/page`, data);
};
//查询钢岚战备大神玩家推荐列表
const getGlGameintroUsers = (data) => {
    return Http('get', `/pdapi/member/hall/cat`, data);
};
//查询钢岚战备机兵涂装库Id
const getGlGamePaintingId = (data) => {
    return Http('get', `/pdapi/partition/querySpecialSubejct`, data);
};
//获取特殊话题列表
const getSpecialSubejct = (data) => {
    return Http('get', `/pdapi/partition/querySpecialSubejct`, data);
};
//首页发现列表接口
const getTopicRecommend = (data) => {
    return Http('get', `/pdapi/topic/recommend/topics`, data);
};
//分区列表
const partitionList = (data) => {
    return Http('get', `/pdapi/partition/list`, data);
};
//查询投票详情
const getVoteInfo = (id) => {
    return Http('get', `/pdapi/topic/vote/${id}`);
};
//投票
const getVote = (id,data) => {
    return Http('post', `/pdapi/topic/vote/${id}`,data);
};

export default {
    getIndexInfo,
    getBanner,
    getProfile,
    getOtherProfile,
    getTopics,
    getDetail,
    getDetail2,
    getCommentList,
    likeClick,
    likeMemberList,
    commentLikeClick,
    commentBadClick,
    getFollows,
    getOtherFollows,
    getFans,
    getOtherFans,
    topicComment,
    favor,
    bad,
    report,
    deletePost,
    deleteComments,
    topicPost,
    subjectCreate,
    subjectList,
    recordlyList,
    messageList,
    follow,
    messageRead,
    replyList,
    queryMessageSet,
    updateMessageSet,
    detail,
    avatar,
    nickname,
    getCosTemToken,
    getSearchData,
    getHotWords,
    getfollowsList,
    feedback,
    shareDetail,
    shareCommentList,
    shareStatistics,
    taglist,
    baikeList,
    webmaster,
    unReadMessageNum,
    findLogincode,
    refreshLogincode,
    bindLogincode,
    unbindLogincode,
    authCond,
    authApply,
    authChange,
    authCancel,
    introduce,
    authTitles,
    sendCode,
    phoneLogin,
    xcxPhoneLogin,
    webLogin,
    webLogoff,
    useBindCode,
    bindCodeQuery,
    bindCode,
    bindPhoneQuery,
    bindPhone,
    getExplist,
    getExGoodsList,
    getExpRule,
    getPointAddList,
    getPointConsList,
    getGoodDetail,
    getRecordList,
    buyGoods,
    getRecordDetail,
    reward,
    daily,
    sign,
    notobtain,
    subTitle,
    profile,
    getGlGameinfo,
    getGlGameintro,
    getGlGameintroBanner,
    getGlGameintroNav,
    getGlGameintroInfos,
    getGlGameintroUsers,
    getGlGameintroNavIcon,
    getGlGamePaintingId,
    getTechRelateInfo,
    getSpecialSubejct,
    topicEdit,
    getTopicRecommend,
    topicEdit,
    partitionList,
    getPartitionList,
    getVoteInfo,
    getVote
}